import { EXPRESS_API } from 'configs/api/expressApi';
import { errorToast } from 'lib/components/toasts/error';
import { successToast } from 'lib/components/toasts/success';
import { useMutation, useQueryClient } from 'react-query';
import { foldersKeys } from './foldersKeys';
import { FoldersV2 } from './getFoldersV2';
import { useTranslation } from 'react-i18next';

export const createFolder = async (body: Partial<FoldersV2>) => {
  const response = await EXPRESS_API.post('/folders', body);
  return response.data;
};

export const useCreateFolderMutation = (onSuccess?: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation((body: Partial<FoldersV2>) => createFolder(body), {
    onError: () => {
      errorToast({
        title: t('An error occurred creating folder, please try again later!'),
      });
    },
    onSuccess: async () => {
      successToast({
        title: t('You have successfully created a new folder'),
      });
      await queryClient.invalidateQueries(foldersKeys.all());
      onSuccess && onSuccess();
    },
  });
};
